import { WEB_PREFIX } from 'constants/common';

export const MODAL = 'modal';
export const TEST_MODAL_START = `${WEB_PREFIX}${MODAL}`;
export const TEST_MODAL_CLOSE_BTN = `${TEST_MODAL_START}_close-button`;
export const TEST_MODAL_DONE_BTN = `${TEST_MODAL_START}_done-button`;
export const TEST_MODAL_SECONDARY_BTN = `${TEST_MODAL_START}_secondary-button`;
